import { MEDIA_CENTER_RAILS_TYPE } from 'hb-react/frontoffice/apps/MediaCenter/utils/queryUtils';
import toggleLike from 'hb-react/shared/components/DesignSystem/Reactions/utils/toggleLike';
import FilePreview from 'hb-react/shared/components/FilePreview';

const MediaCenterFilePreview = ({
  categories,
  comments,
  filePreview,
  folderUrl,
  handleKeyNavigation,
  hasPagination,
  isLoadingComments,
  isLoadingLikes,
  likes,
  nextUrl,
  onCloseModal,
  onCommentCallback,
  onLikeCallback,
  onSwipedLeft,
  onSwipedRight,
  previousUrl,
  search,
  showReactions,
  totalComments,
}) => (
  <FilePreview
    categories={categories}
    content={{
      hideNextUrl: !hasPagination,
      hidePreviousUrl: !hasPagination,
      nextUrl: nextUrl ? { pathname: nextUrl, search } : '',
      onKeyUp: handleKeyNavigation,
      previousUrl: previousUrl ? { pathname: previousUrl, search } : '',
    }}
    file={filePreview}
    folderUrl={folderUrl}
    isLoading={false}
    onCloseModal={onCloseModal}
    onSwipedLeft={onSwipedLeft}
    onSwipedRight={onSwipedRight}
    reactions={{
      comments,
      displayCommentsByDefault: true,
      id: filePreview.id,
      initialLikes: likes,
      initialTotalComments: totalComments,
      isLoadingComments,
      isLoadingLikes,
      onCommentCallback,
      onLikeCallback,
      onTogglePostLike: toggleLike,
      railsType: MEDIA_CENTER_RAILS_TYPE,
      type: MEDIA_CENTER_RAILS_TYPE,
    }}
    screenReadersCloseButtonText={s__(
      'MediaCenterAccessibility|Close preview of media center file',
    )}
    showReactions={showReactions}
  />
);

export default MediaCenterFilePreview;
